import React from "react"
import MetaTags from "react-meta-tags"

import { withRouter } from "react-router-dom"
import {
  Container,
  Card,
  CardBody,
  Label,
  Form,
  Row,
  Button,
  Table,
} from "reactstrap"
import { Link } from "react-router-dom"
import "react-image-lightbox/style.css"

import { useDispatch, useSelector } from "react-redux"
import {
  searchTrackings,
  searchTrackingsError,
  searchSaveKeyword,
} from "store/actions"
import { AvForm } from "availity-reactstrap-validation"
import AvInput from "availity-reactstrap-validation/lib/AvInput"
import SpinnerLoading from "components/CommonForBoth/Loading/Spinner"
import moment from "moment"
import classnames from "classnames"
import Loading from "components/Common/Loading"
import numeral from "numeral"

const Tracking = props => {
  const dispatch = useDispatch()
  const { loading, keyword, oldKeyword, trackingList, trackingError } =
    useSelector(state => ({
      loading: state.TrackingSearch.loading,
      keyword: state.TrackingSearch.keyword,
      oldKeyword: state.TrackingSearch.oldKeyword,
      trackingList: state.TrackingSearch.trackings,
      trackingError: state.TrackingSearch.error,
    }))

  const onSearch = () => {
    if (!keyword.trim()) {
      dispatch(searchTrackingsError("Not found data"))
      return
    }
    dispatch(searchTrackings(keyword))
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Hast | Search Tracking</title>
        </MetaTags>
        <Container fluid>
          <div className="d-flex flex-wrap mt-2 mb-3">
            <h4 className="">Search Tracking</h4>
          </div>
          <Card>
            <CardBody>
              <Label htmlFor="formrow-firstname-Input">
                Input Booking No. or Container No.
              </Label>
              <AvForm
                className="d-flex align-items-center"
                onValidSubmit={(e, v) => {
                  dispatch(searchSaveKeyword(v.keyword))
                  onSearch()
                }}
              >
                <div
                  className="search-box"
                  style={{ width: "100%", marginRight: "1rem" }}
                >
                  <div className="position-relative">
                    <AvInput
                      type="text"
                      name="keyword"
                      className="form-control bg-light border-light rounded"
                      placeholder="Search..."
                      value={keyword || ""}
                      onChange={e =>
                        dispatch(searchSaveKeyword(e.target.value))
                      }
                      disabled={loading}
                    />
                    <i className="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
                <Button
                  color="primary"
                  onClick={() => onSearch()}
                  disabled={loading}
                >
                  Search
                </Button>
              </AvForm>
            </CardBody>
          </Card>
          {loading && <Loading />}
          {!loading && (
            <>
              <div className="popup-gallery d-flex flex-wrap">
                <Row
                  style={
                    trackingError ? { width: "100%", textAlign: "center" } : {}
                  }
                >
                  {trackingError && <p>{trackingError}</p>}
                </Row>
              </div>

              {trackingList.length > 0 && (
                <>
                  <h4 className="font-size-16">
                    Found {oldKeyword} ({numeral(trackingList.length).format("0,0")})
                  </h4>
                  <Card>
                    <CardBody>
                      <div
                        className="table-responsive file-manager"
                        style={{ overflowX: "auto", overflowY: "visible" }}
                      >
                        <Table className="table align-middle table-nowrap table-hover mb-0">
                          <thead>
                            <tr className="text-center">
                              <th
                                scope="col"
                                width="5%"
                                className="d-none d-md-table-cell"
                              >
                                Type
                              </th>
                              <th scope="col">Booking No.</th>
                              <th scope="col">Container No.</th>
                              <th
                                scope="col"
                                className="d-none  d-lg-table-cell"
                              >
                                Created At
                              </th>
                              <th width="10%"></th>
                            </tr>
                          </thead>
                          <tbody>
                            {trackingList.map((trackingList, key) => (
                              <tr key={key}>
                                <td className="text-center d-none d-md-table-cell">
                                  <small
                                    style={{
                                      width: "50px",
                                    }}
                                    className={classnames("badge py-2", {
                                      "bg-success": trackingList.type === "in",
                                      "bg-warning": trackingList.type === "out",
                                    })}
                                  >
                                    {trackingList.type.toUpperCase()}
                                  </small>
                                </td>
                                <td className="text-center">
                                  <small className="d-sm-none">
                                    {trackingList.booking_no}
                                  </small>
                                  <span className="d-none d-sm-inline">
                                    {trackingList.booking_no}
                                  </span>
                                </td>
                                <td className="text-center">
                                  <small className="d-sm-none">
                                    {trackingList.container_no}
                                  </small>
                                  <span className="d-none d-sm-inline">
                                    {trackingList.container_no}
                                  </span>
                                </td>
                                <td className="text-center d-none d-lg-table-cell">
                                  {moment(trackingList.created_at).format(
                                    "DD-MM-YYYY HH:mm:ss"
                                  )}
                                </td>
                                <td>
                                  <Link
                                    to={`/view-tracking?bookingNo=${trackingList.booking_no}&containerNo=${trackingList.container_no}`}
                                  >
                                    view
                                  </Link>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </CardBody>
                  </Card>
                </>
              )}
            </>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Tracking)
